import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';
import { useAppStore } from '../store';

export const ImagePreview: React.FC = () => {
  const capturedImage = useAppStore((state) => state.capturedImage);
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleImageLoad = () => {
    setIsLoading(false);
    setImageError(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setImageError(true);
  };

  if (!capturedImage || imageError) {
    return (
      <div className="aspect-video bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl flex flex-col items-center justify-center gap-4 border border-gray-200 shadow-inner">
        <ImageIcon className="w-16 h-16 text-gray-400" />
        <p className="text-gray-500 text-sm">
          {imageError ? 'Failed to load image' : 'No image captured yet'}
        </p>
      </div>
    );
  }

  return (
    <div className="relative aspect-video bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl overflow-hidden shadow-inner border border-gray-200">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      )}
      <img
        src={capturedImage}
        alt="Captured screen"
        className={`w-full h-full object-contain transition-opacity duration-300 ${
          isLoading ? 'opacity-0' : 'opacity-100'
        }`}
        onLoad={handleImageLoad}
        onError={handleImageError}
        onLoadStart={() => setIsLoading(true)}
      />
    </div>
  );
};